import LocalStorageService from '@/storage/LocalStorageService'
import StorageKeysConfig from '@/storage/StorageKeysConfig'
import { getUserInfo } from '@/storage/services/AppBaseConfigService'

const account = getUserInfo()?.account || ''

const moduleTmp = StorageKeysConfig.VOCUST_HOTEL_CEM_FILTER_KEY
const moduleDefault = StorageKeysConfig.VOCUST_HOTEL_CEM_DEFAULT

export const getHotelCemFilter = () => {
  const filter = LocalStorageService.getItem(moduleTmp.Key)
  if (!filter) {
    return
  }
  filter.dateRange = filter.dateRange ? filter.dateRange.map(item => new Date(item)) : []
  return filter
}
export const setHotelCemFilter = data => {
  LocalStorageService.setItem(moduleTmp.Key, new moduleTmp.EntityClass(data))
}
export const clearHotelCemFilter = () => {
  LocalStorageService.removeItem(moduleTmp.Key)
}

export const getHotelCemDefault = () => {
  const filter = LocalStorageService.getItem(moduleDefault.Key)
  if (!filter) {
    return
  }
  filter.dateRange = filter.dateRange ? filter.dateRange.map(item => new Date(item)) : []
  return filter
}
export const setHotelCemDefault = data => {
  LocalStorageService.setItem(moduleDefault.Key, new moduleDefault.EntityClass(data))
}
export const clearHotelCemDefault = () => {
  LocalStorageService.removeItem(moduleDefault.Key)
}
